//  @flow

import * as React from 'react';

type ShortTextprops = {
  text: string,
  minWords?: number,
  children: (val: string) => React.Node
};

const shortText = ({ text, minWords, children }: ShortTextprops) =>
  typeof text === 'string'
    ? children(text.length <= minWords ? text : `${text.slice(0, minWords)}...`)
    : null;
shortText.defaultProps = {
  minWords: 80
};

export default shortText;



// WEBPACK FOOTER //
// ./src/Components/ShortText/index.js